import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ContractFindInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-find.dto';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { ButtonShowAndHideComponent } from '@zaoblako/web/shared/components/button-show-and-hide/button-show-and-hide.component';
import { CardWidgetTypeEnum } from '@zaoblako/web/shared/components/card-helpdesk-widget/enums/card.widget.type.enum';
import { ConditionalRouterLinkDirective } from '@zaoblako/web/shared/directives/conditional-router-link.directive';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { ContractStatusTypeNamePipe } from '@zaoblako/web/shared/pipes/contract-status-type-name.pipe';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'crm-card-contract-widget',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TooltipModule,
    ButtonShowAndHideComponent,
    CardModule,
    SpinnerComponent,
    TableComponent,
    ContractStatusTypeNamePipe,
    ConditionalRouterLinkDirective
  ],
  templateUrl: './card-contract-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardContractWidgetComponent implements OnInit {
  @Input() public source: CardWidgetTypeEnum;
  @Input() public contracts: ContractFindInterface[];
  @Input() public contractsShow: boolean;
  @Input() public isDisplayCreate = true;
  @Input() public loading: boolean;
  @Input() public isShowCount = false;
  @Input() public count: number;

  @Output() public navigateToContractList = new EventEmitter<void>();
  @Output() public showButtonChange = new EventEmitter<boolean>();
  @Output() public createContract = new EventEmitter<void>();

  public columns: CrmTableColumn[] = [
    { label: 'Контрагент' },
    { label: 'Название' },
    { label: 'Номер' },
    { label: 'Дата' },
    { label: 'Статус' }
  ];

  public get CardWidgetTypeEnum() {
    return CardWidgetTypeEnum;
  }

  public constructor(private readonly router: Router) {}

  public ngOnInit() {
    if (this.source === CardWidgetTypeEnum.CONTRAGENT) {
      this.columns = this.columns.slice(1);
    }
  }

  public toContract(contract: any): ContractFindInterface {
    return contract as ContractFindInterface;
  }

  public directToContractList() {
    const url = String(this.router.createUrlTree(['/client/contract']));
    window.open(url, '_blank');
  }

  public getContractsLabel() {
    return `в список ${this.isShowCount ? '(' + (this.count || 0) + ')' : ''}`;
  }
}
